"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var antd_1 = require("antd");
exports.removeEmpty = function (obj) {
    var listOfKeys = Object.keys(obj);
    var filteredObject = listOfKeys.filter(function (k) {
        var value = obj[k];
        var valueIsNotNull = value != null;
        var valueIsNotUndefined = value !== undefined;
        var valueIsNotEmptyString = value !== '';
        return valueIsNotNull
            && valueIsNotUndefined
            && valueIsNotEmptyString;
    }); // Remove undef. and null.
    var reducedObject = filteredObject.reduce(function (newObj, k) {
        var _a, _b;
        return typeof obj[k] === "object"
            ? __assign({}, newObj, (_a = {}, _a[k] = exports.removeEmpty(obj[k]), _a)) : __assign({}, newObj, (_b = {}, _b[k] = obj[k], _b));
    }, // Copy value.
    {});
    return reducedObject;
};
var convertDates = function (date) {
    return date ? date.utc().toDate() : undefined;
};
var isEmpty = function (map) {
    for (var key in map) {
        if (map.hasOwnProperty(key)) {
            return false;
        }
    }
    return true;
};
var getIdentifierWithPrefix = function (identifier) {
    if (!identifier.startsWith("0196:")) {
        return "0196:" + cleanIdentifier(identifier);
    }
    else {
        return cleanIdentifier(identifier);
    }
};
var cleanIdentifier = function (identifier) {
    // return identifier.replace(/[^0-9]/g, "") // replace anything that isn't a numeric character
    return identifier.replace("-", ""); // remove the '-'
};
var convertToInvoiceMetadataInput = function (formValues, invoiceLinesWithCalculations, paymentMethod, chosenCustomer) {
    var issueDate = convertDates(formValues.invoice.issueDate);
    var dueDate = convertDates(formValues.invoice.dueDate);
    var referenceIdentifiersArray = formValues.invoice && formValues.invoice.singleReferenceIdentifier && formValues.invoice.singleReferenceIdentifier.code && formValues.invoice.singleReferenceIdentifier.value
        ? [{
                code: {
                    value: formValues.invoice.singleReferenceIdentifier.code
                },
                value: formValues.invoice.singleReferenceIdentifier.value
            }]
        : formValues.invoice.referenceIdentifiers;
    var cleanedFormValues = exports.removeEmpty(formValues);
    var invoice = cleanedFormValues.invoice;
    // fix delivery
    var delivery = invoice.delivery;
    if (delivery) {
        if (isEmpty(delivery.address)) {
            delete delivery.address;
        }
        if (Object.keys(delivery).length === 0 && delivery.constructor === Object) {
            delivery = undefined;
        }
    }
    // const referenceIdentifiers: ReferenceIdentifierMetadata[] | null | undefined =
    //     referenceIdentifiersArray
    //         ? referenceIdentifiersArray.length === 0
    //         ? null
    //         : referenceIdentifiersArray.map(referenceId => (
    //             {
    //                 code: referenceId.code!.value,
    //                 value: referenceId.value
    //             })
    //         )
    //         : null;
    var referenceIdentifiers = referenceIdentifiersArray
        ? referenceIdentifiersArray.length === 0
            ? null
            : referenceIdentifiersArray[0].code
                ?
                    // TODO: handle multiple?
                    [{
                            code: referenceIdentifiersArray[0].code.value,
                            value: referenceIdentifiersArray[0].value
                        }]
                : null
        : null;
    var getMessageHandling = function (partyMetadata) {
        if (!partyMetadata) {
            antd_1.message.error("There is an error in the configuration file for the receiver information");
            throw new Error("There is an error in the configuration file for the receiver information");
        }
        return {
            receiverIdentifier: partyMetadata.identifier,
            fallbackEmailAddress: partyMetadata.contact && partyMetadata.contact.electronicMail ? partyMetadata.contact.electronicMail : "",
            fallbackContactName: partyMetadata.name
        };
    };
    var vatNumber = invoice.supplier.vatNumber ? invoice.supplier.vatNumber : null;
    var orderReference = invoice.orderReference && invoice.orderReference.hasOwnProperty("documentNo")
        ? invoice.orderReference
        : undefined;
    // NBNB: FOR NOW THIS IS ONLY FOR PROJECT, CREATE FUNCTION THAT WOULD RETURN CORRECT OBJECT STRUCTURE IF OTHER PROPERTIES ARE BEING USED
    var documentReferences = invoice.documentReferences
        && invoice.documentReferences.project
        && invoice.documentReferences.project.documentNo
        ? invoice.documentReferences
        : undefined;
    var resp = {
        messageHandling: getMessageHandling(chosenCustomer),
        invoice: {
            customer: {
                identifier: getIdentifierWithPrefix(chosenCustomer.identifier),
                address: {
                    streetNameAndNumber: chosenCustomer.address.streetNameAndNumber,
                    postalZone: chosenCustomer.address.postalZone,
                    city: chosenCustomer.address.city,
                    countryCode: chosenCustomer.address.countryCode
                },
                name: chosenCustomer.name,
                contact: {
                    electronicMail: chosenCustomer.contact.electronicMail,
                    telephone: chosenCustomer.contact.telephone,
                    name: invoice.customer.contact && invoice.customer.contact.name ? invoice.customer.contact.name : undefined,
                },
                locationIdentifier: invoice.customer.locationIdentifier,
            },
            supplier: {
                identifier: getIdentifierWithPrefix(invoice.supplier.identifier),
                address: {
                    streetNameAndNumber: invoice.supplier.address.streetNameAndNumber,
                    postalZone: invoice.supplier.address.postalZone,
                    city: invoice.supplier.address.city,
                    countryCode: invoice.supplier.address.countryCode,
                },
                vatNumber: vatNumber,
                name: invoice.supplier.name,
                contact: {
                    electronicMail: invoice.supplier.contact.electronicMail,
                    name: invoice.supplier.contact.name,
                },
            },
            delivery: delivery,
            invoiceNo: invoice.invoiceNo,
            issueDate: issueDate,
            dueDate: dueDate,
            notes: invoice.notes,
            currencyCode: invoice.currencyCode,
            invoiceLines: invoiceLinesWithCalculations,
            // invoiceLines: invoice.invoiceLines, // FOR NEW BILLING LINES
            // payableAmount: 0, // Calculated? either doesnt exist or part of the Billing/Invoice Lines
            buyerReference: invoice.buyerReference,
            paymentMeans: paymentMethod,
            referenceIdentifiers: referenceIdentifiers,
            documentReferences: documentReferences,
            orderReference: orderReference,
            documentDescriptions: [
                {
                    identifier: "UNIMAZE-BILLING-WEB",
                    description: location.hostname,
                }
            ],
        }
    };
    if (resp.invoice && resp.invoice.delivery && resp.invoice.delivery === {}) {
        delete resp.invoice.delivery;
    }
    if (resp.invoice && !resp.invoice.orderReference) {
        delete resp.invoice.orderReference;
    }
    return resp;
};
exports.convertToInvoiceMetadataInput = convertToInvoiceMetadataInput;
var profileOutputToPartyMetadata = function (profileOutput) {
    if (!profileOutput.participantLegalIsoIdentifier || !profileOutput.participantLegalAddressStreet || !profileOutput.name || !profileOutput.country) {
        var errorMessage = "There was an error with the customer information, please check the application configuration";
        antd_1.message.error(errorMessage);
        throw new Error(errorMessage);
    }
    return {
        identifier: profileOutput.participantLegalIsoIdentifier,
        address: {
            streetNameAndNumber: profileOutput.participantLegalAddressStreet,
            city: profileOutput.participantLegalAddressCity,
            countryCode: profileOutput.country,
            postalZone: profileOutput.participantLegalAddressPostalCode
        },
        name: profileOutput.name,
        contact: {
            electronicMail: profileOutput.email,
            telephone: profileOutput.phoneNumber
        }
    };
};
exports.profileOutputToPartyMetadata = profileOutputToPartyMetadata;
var convertToReadableKennitala = function (isoIdentifier) {
    return isoIdentifier.substr(5, 6) + "-" + isoIdentifier.substr(11);
};
exports.convertToReadableKennitala = convertToReadableKennitala;
